var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"popup-box",style:(_vm.boxPositon=='up'?'bottom:-350px':'bottom:0px')},[_c('div',{staticClass:"popup-box_up",on:{"click":_vm.setPosition}},[_c('span',[_vm._v("向上")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }